import useSwr from "@/core/composables/swr/useSwr";
import {cacheKey} from "@/lib/cache";
import {videoApi} from "@/container";

/**
 * The tag identifying the Apodis birthday stock videos in the main API catalog.
 */
const BIRTHDAY_VIDEO_TAG = 'birthday';

/**
 * The Apodis birthday stock videos offered to the pharmacy.
 */
const useBirthdayStockVideos = () => {
    return useSwr(
        cacheKey('videos', {tags: [BIRTHDAY_VIDEO_TAG]}),
        async () => {
            const response = await videoApi().index({tags: [BIRTHDAY_VIDEO_TAG], limit: 20});

            return response.data;
        }
    );
};

export default useBirthdayStockVideos;
